import Axios from 'axios';

const axiosInstance = Axios.create({
  baseURL: `${location.protocol}//${location.hostname}:${location.port}/`,
  headers: {
    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]') ? document.querySelector('meta[name="csrf-token"]').getAttribute('content') : ''
  }
});

export default axiosInstance;